import axios from 'axios'
import { config } from '../../config'
import { APP_CONSTANTS } from '../../utils/AppConstants'
import API_ENDPOINTS from './endpoints'

export function addProjectAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.project.addProject}`,
        data: payload,
        headers: {
            'authToken': user ? user.authToken : config.cid,
            "Content-Type": "multipart/form-data"
        }
    })
}

export function projectListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.project.projectList}`,
        params: payload,
        headers: {
            'authToken': user ? user.authToken : config.cid
        }
    })
}

export function projectDetailAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.project.projectDetail}/${payload.projectId}`,
        params: payload.params,
        headers: {
            'authToken': user ? user.authToken : config.cid
        }
    })
}

export function updateProjectDetailAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        data: payload,
        url: `${config.baseUrl}/${API_ENDPOINTS.project.updateDetails}`,
        headers: {
            'authToken': user ? user.authToken : config.cid,
            "Content-Type": "multipart/form-data"
        }
    })
}

export function rejectProjectRequestAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        data: payload,
        url: `${config.baseUrl}/${API_ENDPOINTS.project.rejectRequest}`,
        headers: {
            'authToken': user ? user.authToken : config.cid
        }
    })
}

export function requestProjectAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        data: payload,
        url: `${config.baseUrl}/${API_ENDPOINTS.project.requestProject}`,
        headers: {
            'authToken': user ? user.authToken : config.cid
        }
    })
}

export function projectAssignEmployeeAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        data: payload,
        url: `${config.baseUrl}/${API_ENDPOINTS.project.assignEmployee}`,
        headers: {
            'authToken': user ? user.authToken : config.cid
        }
    })
}

export function projectRemoveEmployeeAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        data: payload,
        url: `${config.baseUrl}/${API_ENDPOINTS.project.removeEmployee}`,
        headers: {
            'authToken': user ? user.authToken : config.cid
        }
    })
}